document.addEventListener('click', event => {
  const button = event.target.closest('[data-sport-param]');
  if (!button) return;
  const url = new URL(location.href);
  const key = button.dataset.sportParam, value = button.dataset.sportValue;
  const values = url.searchParams.getAll(key);
  url.searchParams.delete(key);
  if (!values.includes(value)) url.searchParams.append(key, value);
  url.searchParams.delete('page');
  const facets = document.querySelector('facets-form-component');
  if (facets?.updateFiltersByURL) facets.updateFiltersByURL(url.toString());
  else location.assign(url.toString());
});
